import type { OwnerBooking } from '../api/bookings.api.js';

export type AdminBookingRow = OwnerBooking & { groupedBookings: OwnerBooking[] };

export function groupAdminBookings(bookings: OwnerBooking[]): AdminBookingRow[] {
  const groups = new Map<string, OwnerBooking[]>();
  for (const booking of bookings) {
    const key = booking.bookingGroupId ?? booking.id;
    groups.set(key, [...(groups.get(key) ?? []), booking]);
  }
  return Array.from(groups.values()).map((group) => {
    const items = [...group].sort(
      (a, b) => Date.parse(a.slot.startTime) - Date.parse(b.slot.startTime),
    );
    const first = items[0]!;
    // Keep an actionable slot as the representative while a visit is in progress.
    const representative =
      items.find((item) => item.status === 'ACTIVE') ??
      items.find((item) => ['PENDING', 'PAID'].includes(item.status)) ??
      first;
    const total = (
      key:
        | 'basePriceInSmallestUnit'
        | 'priceInSmallestUnit'
        | 'referralDiscountInSmallestUnit'
        | 'promoDiscountInSmallestUnit'
        | 'creditAppliedInSmallestUnit'
        | 'partnerPriceInSmallestUnit',
    ) => items.reduce((sum, item) => sum + item[key], 0);
    return {
      ...representative,
      id: first.id,
      basePriceInSmallestUnit: total('basePriceInSmallestUnit'),
      priceInSmallestUnit: total('priceInSmallestUnit'),
      referralDiscountInSmallestUnit: total('referralDiscountInSmallestUnit'),
      promoDiscountInSmallestUnit: total('promoDiscountInSmallestUnit'),
      creditAppliedInSmallestUnit: total('creditAppliedInSmallestUnit'),
      partnerPriceInSmallestUnit: total('partnerPriceInSmallestUnit'),
      slot: { ...first.slot, endTime: items[items.length - 1]!.slot.endTime },
      groupedBookings: items,
    };
  });
}
